import React from 'react';

import { isValidExternalURL } from '@/utils/url.util';

export const parseDataFindingExamples = (
  dataFindingText: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  wizData: any
) => {
  if (
    wizData.dataFindingExamples &&
    Array.isArray(wizData.dataFindingExamples)
  ) {
    return wizData.dataFindingExamples;
  }

  const anchor = 'dataFindingExamples:';
  const anchorIdx = dataFindingText.indexOf(anchor);
  if (anchorIdx !== -1) {
    let valueStart = anchorIdx + anchor.length;
    while (
      valueStart < dataFindingText.length &&
      /\s/.test(dataFindingText[valueStart])
    ) {
      valueStart++;
    }
    if (
      valueStart >= dataFindingText.length ||
      dataFindingText[valueStart] !== '['
    ) {
      return [];
    }
    const bracketStart = valueStart;
    let depth = 0;
    let inString = false;
    let escape = false;
    for (let i = bracketStart; i < dataFindingText.length; i++) {
      const ch = dataFindingText[i];
      if (escape) {
        escape = false;
        continue;
      }
      if (ch === '\\' && inString) {
        escape = true;
        continue;
      }
      if (ch === '"') {
        inString = !inString;
        continue;
      }
      if (inString) continue;
      if (ch === '[') depth++;
      else if (ch === ']') {
        depth--;
        if (depth === 0) {
          try {
            const examples = JSON.parse(
              dataFindingText.slice(bracketStart, i + 1)
            );
            return Array.isArray(examples) ? examples : [];
          } catch (e) {
            console.warn('Failed to parse data finding examples:', e);
          }
          break;
        }
      }
    }
  }
  return [];
};

export const extractField = (
  text: string,
  fieldName: string
): string | undefined => {
  const lines = text.split('\n');
  for (const line of lines) {
    if (
      line
        .trimStart()
        .toLowerCase()
        .startsWith(fieldName.toLowerCase() + ':')
    ) {
      const parts = line.split(':');
      if (parts.length > 1) {
        return parts.slice(1).join(':').trim();
      }
    }
  }
  return undefined;
};

export const getCvssColor = (score: string | number) => {
  const numScore = typeof score === 'string' ? parseFloat(score) : score;
  if (numScore >= 9.0) return 'text-error';
  if (numScore >= 7.0) return 'text-warning';
  if (numScore >= 4.0) return 'text-warning';
  return 'text-success';
};

export const getCvssBgColor = (score: string | number) => {
  const numScore = typeof score === 'string' ? parseFloat(score) : score;
  if (numScore >= 9.0) return 'bg-error/10';
  if (numScore >= 7.0) return 'bg-warning/10';
  if (numScore >= 4.0) return 'bg-warning/10';
  return 'bg-success/10';
};

export const getCvssLabel = (score: string | number) => {
  const numScore = typeof score === 'string' ? parseFloat(score) : score;
  if (numScore >= 9.0) return 'Critical';
  if (numScore >= 7.0) return 'High';
  if (numScore >= 4.0) return 'Medium';
  return 'Low';
};

export const formatValue = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  val: any,
  propKey: string
): React.ReactNode => {
  if (typeof val === 'object' && val !== null) {
    return null; // We'll handle this in the main loop
  } else if (
    typeof val === 'string' &&
    (val.includes('\n') || val.includes('•'))
  ) {
    const lines = val.split('\n').filter(line => line.trim());
    const hasStructuredData = lines.some(
      line => line.includes(':') || line.startsWith('•')
    );

    if (hasStructuredData) {
      return null; // We'll handle this in the main loop
    }
    return (
      <span className="text-chariot-text-primary whitespace-pre-line">
        {val}
      </span>
    );
  } else if (typeof val === 'string' && val.length > 100) {
    return (
      <span className="text-chariot-text-primary max-w-md text-right break-all">
        {val}
      </span>
    );
  } else {
    const strValue = String(val);
    if (
      (propKey.toLowerCase().includes('url') || strValue.startsWith('http')) &&
      isValidExternalURL(strValue)
    ) {
      return (
        <a
          href={strValue}
          target="_blank"
          rel="noopener noreferrer"
          className="text-chariot-brand-primary max-w-md text-right break-all hover:underline"
        >
          {strValue}
        </a>
      );
    }
    return <span className="text-chariot-text-primary">{strValue}</span>;
  }
};
